import { Controller } from "stimulus"

/* TinyMCE core */
require('tinymce/tinymce');

/* Theme - required for TinyMCE */
require('tinymce/themes/silver');

/* Icons - required */
require('tinymce/icons/default');

/* Models - required for TinyMCE 6+ */
require('tinymce/models/dom');

/* Plugins */
require('tinymce/plugins/link');
require('tinymce/plugins/lists');

// copy tinymce's skins directory into public/packs
require.context(
  '!file-loader?name=[path][name].[ext]&context=node_modules/tinymce&outputPath=js!tinymce/skins',
  true,
  /.*/
);

export default class extends Controller {
  static targets = [ 'textarea' ]

  connect() {
    tinymce.init({
      selector: '.tinymce',
      license_key: 'gpl', // Required for TinyMCE 7+ when self-hosting under GPL
      menubar: false,
      statusbar: false,
      plugins: ['link', 'lists'], // 'paste' is now built into core
      toolbar: ['numlist bullist alignleft aligncenter link bold italic underline'],
      branding: false,
      inline_styles: false,
      height: '180',
      placeholder: this.data.get('placeholder'),
      content_style: '.mce-content-body[data-mce-placeholder] { cursor: text; color: #a1a5ad; }' +
                     '.mce-content-body { font-family: "Proxima Nova", sans-serif; color: #4a5162; line-height: 1.325;}',
    });
  }
}
